import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { Box, Typography } from '@mui/material';
import Countdown from 'react-countdown';
import { blackNovemberPromotionData } from 'utils';
import CustomButton from 'components/CustomButton';
import { useStyles } from './styles';
import Image from 'next/image';

export default function CountdownBanner() {
  const router = useRouter();
  const classes = useStyles();
  const promotionData = blackNovemberPromotionData();
  const isHomePage = router.pathname === '/';
  const isBlackNovemberPage = router.pathname === '/blacknovember';

  if (isHomePage && (promotionData.isPreActive || promotionData.isActive)) {
    return (
      <div className={classes.root}>
        <Box pr={1}>
          <Image
            src="/images/black-november-2023.svg"
            alt="logo black november"
            width={256}
            height={60}
          />
        </Box>

        <Typography className={classes.text} variant="h6">
          <b>Sale Extended Until Dec 3rd</b>
        </Typography>

        {/* <Countdown
          date={
            promotionData.isPreActive ? promotionData.preActiveEndDate : promotionData.activeEndDate
          }
          renderer={({ formatted: { days, hours, minutes, seconds } }) => (
            <div className={classes.timer}>
              <div className={classes.timerItem}>
                <Typography variant="h6">
                  <b>{days}</b>
                </Typography>
                <small>days</small>
              </div>

              <div className={classes.timerItem}>
                <Typography variant="h6">
                  <b>{hours}</b>
                </Typography>
                <small>hours</small>
              </div>

              <div className={classes.timerItem}>
                <Typography variant="h6">
                  <b>{minutes}</b>
                </Typography>
                <small>minutes</small>
              </div>

              <div className={classes.timerItem}>
                <Typography variant="h6">
                  <b>{seconds}</b>
                </Typography>
                <small>seconds</small>
              </div>
            </div>
          )}
        /> */}

        {promotionData.isActive && (
          <Box ml={4}>
            <Link href="/blacknovember" prefetch={false} passHref>
              <CustomButton>
                <b>Learn More</b>
              </CustomButton>
            </Link>
          </Box>
        )}
      </div>
    );
  }

  if (isBlackNovemberPage && promotionData.isActive) {
    return (
      <div className={classes.root}>
        <Typography className={classes.text} variant="h6">
          <b>Our Black November ends in</b>
        </Typography>

        <Countdown
          date={promotionData.activeEndDate}
          renderer={({ formatted: { days, hours, minutes, seconds } }) => (
            <div className={classes.timer}>
              <div className={classes.timerItem}>
                <Typography variant="h6">
                  <b>{days}</b>
                </Typography>
                <small>days</small>
              </div>

              <div className={classes.timerItem}>
                <Typography variant="h6">
                  <b>{hours}</b>
                </Typography>
                <small>hours</small>
              </div>

              <div className={classes.timerItem}>
                <Typography variant="h6">
                  <b>{minutes}</b>
                </Typography>
                <small>minutes</small>
              </div>

              <div className={classes.timerItem}>
                <Typography variant="h6">
                  <b>{seconds}</b>
                </Typography>
                <small>seconds</small>
              </div>
            </div>
          )}
        />
      </div>
    );
  }
}
